/**
 * Canonical fallback rest time, in seconds, for a program/template exercise.
 *
 * Mirrors `com.progress.constants.RestTimeDefaults` on the server — keep the two in sync.
 *
 * Rest time used to be nullable end to end. Clearing the rest-time cell in the week editor wrote an
 * empty string straight onto the exercise, which persisted as `rest_time = NULL`; the mobile app
 * then called `startTimer(undefined)` and rendered "NaN:NaN" on a rest timer that never counted
 * down. Migration V20260812 backfilled the nulls and made the column NOT NULL.
 *
 * Zero is a legitimate value and must never be coerced to this default — cardio exercises are
 * deliberately created with a rest time of 0 — so callers should null/NaN-check explicitly rather
 * than using `restTime || DEFAULT_REST_TIME_SECONDS`.
 */
export const DEFAULT_REST_TIME_SECONDS = 120;
